import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { cmsWebContent } from 'redux/saga/entities/bound';
import { cmsDataToModuleArray } from 'components/CmsPage/cmsDataToModuleArray';
import { CmsModules, CmsModuleShape } from './CmsModules';
import { loadCmsContent, watchCmsContentSagas } from './cms-content.saga';

export class CmsContentUnwrapped extends Component {
  componentDidMount() {
    const { slugs } = this.props;
    this.props.loadContent(slugs);
  }

  componentDidUpdate(prevProps) {
    const { slugs } = this.props;
    if (JSON.stringify(slugs) !== JSON.stringify(prevProps.slugs)) {
      this.props.loadContent(slugs);
    }
  }

  render() {
    return <CmsModules modules={this.props.modules} />;
  }
}

CmsContentUnwrapped.propTypes = {
  loadContent: PropTypes.func.isRequired,
  modules: PropTypes.arrayOf(CmsModuleShape),
  slugs: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};

const mapStateToProps = (state, props) => {
  const cmsData = props.slugs.map(slug => cmsWebContent.data(state, slug)).find(Boolean) || {};
  // This component takes an array of slugs ordered from highest ranked to lowest
  // We want to return the content corresponding to the highest ranked matching slug
  return { modules: cmsDataToModuleArray(state, cmsData) };
};

const mapDispatchToProps = {
  loadContent: loadCmsContent,
};

export const CmsContent = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSagas({ watch: watchCmsContentSagas }),
  withName('CmsContent')
)(CmsContentUnwrapped);
